import { Language } from '@shared/app/scripts/services/language';

/**
 * Shows the <terms-and-conditions> component
 */
angular.module('gateApp').component('termsAndConditions', {
  template: require('./terms-and-conditions.html').default,
  controller: function ($sce: ng.ISCEService, language: Language) {
    const $ctrl = this;

    $ctrl.currentLanguage$ = language.current$;

    $ctrl.content = {
      // legal i18n list
      'nl-nl': $sce.trustAsHtml(require('./nl-nl.html').default),
      'en-gb': $sce.trustAsHtml(require('./en-gb.html').default),
    };
  },
});
